// Vue
import { Component, Prop, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { EventBus } from "@mgs/ci2019-common/src/mixins/event_bus/EventBus";
import { ModuleHelperMixin } from "#/common/ModuleHelperMixin";
// Template
import template from "./template.vue";
import { getTranslatedImage } from "#/common/ModuleHelpers";
import { TextBildModule } from "#/modules/aufbauplus/text_bild_module/TextBildModule";

@Component({
  mixins: [template],
  components: {
    TextBildModule,
  },
})
export class SliderItemAufbauplus extends mixins(EventBus, ModuleHelperMixin) {
  @Prop()
  public instance!: object;

  @Prop({ default: false })
  public active!: boolean;

  @Prop()
  public slide!: object;

  @Prop()
  public lang!: string;

  @Prop({ default: true })
  public shouldNotify!: boolean;

  public created() {
    if (this.shouldNotify) {
      let duration = this.slide["duration"] * 1000;
      if (this.slide["images"] && this.slide["images"].length > 1) {
        duration = 0;
        this.slide["images"].forEach((image) => {
          duration += image.duration * 1000;
        });
      }

      let modInstance = {
        background: "white",
        type: "type-a",
        headline: {
          type: "big",
          text: this.slide["headline"],
        },
        content: this.slide["text"],
        section_position_columns: {
          position: "right",
          column_size_image: "7",
          column_size_text: "7",
        },
        section_image: {
          image: this.slide["image"],
        },
        common_options: this.instance["common_options"],
      };

      this.dispatch("Slider", "registerSlide", [
        {
          active: this.active,
          duration: duration,
          text: "",
          component: "SliderItemAufbauplus",
          props: {
            slide: this.slide,
            lang: this.lang,
            instance: modInstance,
          },
        },
      ]);
    }
  }
}
